import { createContext, Dispatch, SetStateAction } from 'react';

import { ClientMessage, ConversationData, PendingAssetWithID } from '../types';

/**
 * This context allows for maintaining a shared state across various implementations of the CanaryAI
 * <Chat> component. It also allows for maintaining a single in-progress chat after navigating
 * away and back to the Chat component. It manages all the data involved in a single conversation
 * and creates and maintains websocket connections with the wingmate service (1 connection per user-message,
 * agent-response pair)
 */
export interface CanaryAIContextValue {
  isGeneratingAgentResponse: boolean;
  setCurrentConversationId: Dispatch<SetStateAction<string | null>>;
  currentConversationData: ConversationData | null;
  sendUserMessage: (messageText: string) => void;
  messages: ClientMessage[];
  setNewConversationTrigger: Dispatch<SetStateAction<string | null>>;
  setPendingAssets: Dispatch<SetStateAction<PendingAssetWithID[]>>;
  pendingAssets: PendingAssetWithID[];
  setTriggerScrollToBottom: Dispatch<SetStateAction<number>>;
  triggerScrollToBottom: number;
  setAnswerSeen: (hasSeen: boolean) => void;
  isAnswerSeen: boolean;
  setIsE2ETestMode: Dispatch<SetStateAction<boolean>>;
}

export const CanaryAIContext = createContext<CanaryAIContextValue>({
  isGeneratingAgentResponse: false,
  setCurrentConversationId: () => void 0,
  currentConversationData: null,
  sendUserMessage: () => void 0,
  messages: [],
  setNewConversationTrigger: () => void 0,
  setPendingAssets: () => void 0,
  pendingAssets: [],
  setTriggerScrollToBottom: () => void 0,
  triggerScrollToBottom: 0,
  setAnswerSeen: () => void 0,
  isAnswerSeen: false,
  setIsE2ETestMode: () => void 0,
});
